// extracted by mini-css-extract-plugin
export var flexbar = "social-module--flexbar--aHw-T";
export var iconsbar = "social-module--iconsbar--YmENd";
export var iconsizebar = "social-module--iconsizebar--sWZ-J";
export var icontext = "social-module--icontext--5jKEl";
export var searchbtnbar = "social-module--searchbtnbar--bUnv2";
export var socialbar = "social-module--socialbar--Hw0xi";